import React from "react";
import * as S from "./styled";

const NoSearch = () => {
  return (
    <S.Wrapper>
      <h1>Pesquise o usuário no campo acima</h1>
    </S.Wrapper>
  );
};

export default NoSearch;